import Anchor from "components/Anchor/Anchor";
import ImageViewer from "components/ImageViewer/ImageViewer";
import React, { FunctionComponent } from "react";
import { useSelector } from "react-redux";
import LogoProps from "./LogoProps.interface";
import styles from "./Logo.module.scss";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import combineClasses from "helpers/combine-classes";

const Logo: FunctionComponent<LogoProps> = (props) => {
    const { header } = props;
    const page = useSelector(state => state.page.content);

    const imageAspectRatio = getImageAspectRatio(undefined, header?.logo?.umbracoWidth, header?.logo?.umbracoHeight);

    const moodBannerClass = props.isMoodBanner ? styles.mood_banner_first : undefined;
    const isNotMoodBannerClass = !props.isMoodBanner ? styles.not_mood_banner_first : undefined;
    const isHeaderTopClass = props.isHeaderTop ? styles.is_header_top : undefined;

    return (
        <Anchor className={combineClasses(styles.logo_link, moodBannerClass, isNotMoodBannerClass, isHeaderTopClass)} to={page?._homeNodeUrl} >
            {header?.logo && header?.logo.umbracoExtension === "png" ? (
                <ImageViewer className={styles.logo} src={header?.logo.umbracoFile.src} extensionType={header?.logo.umbracoExtension} type="contain" aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} />
            ) : null}

            {header?.logo && header?.logo.umbracoExtension === "svg" ? (
                <img className={styles.logo} src={header?.logo._url} />
            ) : null}
        </Anchor>
    );
};

export default Logo;